import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { UXCustomizationType } from "@gtmhub/uxcustomization/models";
import { NavigationItemsFacade } from "@gtmhub/uxcustomization/navigation-items-facade";
import { NavItemsType } from "@webapp/navigation/models/nav-items-list.models";

@Injectable()
export class BaseRecentSubNav implements OnInit, OnDestroy {
  protected navigationItemsFacade: NavigationItemsFacade;

  public ngOnInit() {
    this.navigationItemsFacade.setupRecents();
    this.navigationItemsFacade.setupFavorites();
  }

  public ngOnDestroy() {
    this.navigationItemsFacade.unsubscribeRecents();
  }

  public getRecent() {
    return this.navigationItemsFacade.getRecentItems();
  }

  public getFavorites() {
    return this.navigationItemsFacade.getFavoriteItems();
  }

  protected setupEntityTypes(entityTypes: UXCustomizationType[], entityNavType: NavItemsType) {
    this.navigationItemsFacade.setupEntityTypes(entityTypes, entityNavType);
  }
}
